import { API_TYPE, fetchData, IResponse } from '@umu/umu-fetch';
import { IAiToolsPointsData } from '../interface/aiTools';
import { handlePromiseError } from 'common/utils/errorHandler';
const PHP_BASE = '/uapi/v1';
const API = {
    GET_AI_TOOLS_LIST: {
        url: `${PHP_BASE}/commodity/ai-tools-points`,
        type: API_TYPE.GET,
    },
};

export const getAiToolsPointsPackageList = async (): Promise<IAiToolsPointsData> => {
    return fetchData(API.GET_AI_TOOLS_LIST)
        .then((res: IResponse<IAiToolsPointsData>) => {
            return res.data;
        })
        .catch((error: unknown) => {
            handlePromiseError(error, 'getAiToolsPointsPackageList', 'getAiToolsPointsPackageList fetchData error');
        });
};
